


// import React from "react";
// import { Link } from "react-router-dom";
// import "../styles/about.css";
// import aboutImg from "../images/about-industrial.png";

// function About() {
//   return (
//     <section className="about">
//       <div className="container about-flex">

//         {/* TEXT */}
//         <div className="about-text">
//           <span className="about-tag">About Us</span>

//           <h2>
//             Trusted Industrial Trading <br />
//             Partner You Can Rely On
//           </h2>

//           <p>
//             Apex Trade Connect FZ-LLC is a general trading company specializing in
//             a diverse range of industrial products. We are committed to quality,
//             reliability, and building long-term partnerships across industries.
//           </p>

//           <ul className="about-points">
//             <li>
//               <i className="fa fa-industry"></i>
//               Wide range of industrial products
//             </li>
//             <li>
//               <i className="fa fa-truck"></i>
//               Reliable and efficient supply chain
//             </li>
//             <li>
//               <i className="fa fa-handshake-o"></i>
//               Customer-focused trading solutions
//             </li>
//           </ul>

//           <Link to="/about" className="about-btn">
//             Read More
//             <i className="fa fa-arrow-right"></i>
//           </Link>
//         </div>

//         {/* IMAGE */}
//         <div className="about-image">
//           <img src={aboutImg} alt="Industrial Trading" />
//         </div>

//       </div>
//     </section>
//   );
// }

// export default About;


import React from "react";
import "../styles/about-page.css";
import aboutImg from "../images/about-industrial.webp";

function About() {
  return (
    <>
      {/* HERO */}
      <section className="about-hero">
        <div className="container">
          <h1>About Apex Trade Connect</h1>
          <p>
            Your trusted partner for industrial trading solutions built on
            quality, reliability, and long-term relationships.
          </p>
        </div>
      </section>

      {/* OVERVIEW */}
      <section className="about-section">
        <div className="container about-grid">

          <div className="about-content">
            <span className="about-tag">Who We Are</span>
            <h2>Delivering Trusted Industrial Solutions</h2>

            <p>
              Apex Trade Connect FZ-LLC is a general trading company based in
              Ras Al Khaimah, United Arab Emirates. We specialize in sourcing
              and supplying a wide range of industrial products to meet the
              evolving needs of various industries.
            </p>

            <p>
              Our focus is on building strong partnerships by delivering
              consistent quality, dependable supply chains, and professional
              service.
            </p>
          </div>

          <div className="about-image">
            <img src={aboutImg} alt="Industrial Solutions" />
          </div>

        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="about-features">
        <div className="container">
          <h2 className="section-title">Why Choose Apex Trade Connect</h2>

          <div className="features-grid">
            <div className="feature-card">
              <i className="fa fa-industry"></i>
              <h4>Wide Product Range</h4>
              <p>
                Comprehensive industrial products catering to multiple sectors.
              </p>
            </div>

            <div className="feature-card">
              <i className="fa fa-truck"></i>
              <h4>Reliable Supply Chain</h4>
              <p>
                Efficient sourcing and timely delivery you can rely on.
              </p>
            </div>

            <div className="feature-card">
              <i className="fa fa-handshake-o"></i>
              <h4>Customer Focused</h4>
              <p>
                Solutions tailored to customer requirements and long-term value.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="about-mission">
        <div className="container mission-grid">

          <div className="mission-box">
            <h3>Our Mission</h3>
            <p>
              To provide high-quality industrial products through reliable
              sourcing and professional service, creating lasting partnerships
              with our clients.
            </p>
          </div>

          <div className="mission-box">
            <h3>Our Vision</h3>
            <p>
              To be a trusted industrial trading partner recognized for
              integrity, efficiency, and customer satisfaction.
            </p>
          </div>

        </div>
      </section>
    </>
  );
}

export default About;
